<template>
  <div class='container' v-loading.fullscreen.lock="isStop == false && curMode == modeList[1]"
    element-loading-text="自动抽奖中...">
    <!-- 抽奖显示区域：代号在上，姓名在下 -->
    <div class="show-name" @click="clickBtn">
      <div v-if="nameList.length == 0" class="empty-tip">
        {{ noDataTip }}
      </div>
      <div v-else class="person-info">
        <span class="symbol-text">{{ curPerson.symbol || '无代号' }}</span>
        <span class="name-text">{{ curPerson.name || '无姓名' }}</span>
      </div>
    </div>
    <!--控制盒子-->
    <el-form class="control-div">
      <el-form-item label="抽奖模式：">
        <el-radio-group v-model="curMode">
          <el-radio-button v-for="item in modeList" :key="item" :label="item" />
        </el-radio-group>
      </el-form-item>
      <el-form-item label="奖项切换：" v-show="curMode == modeList[0]">
        <el-radio-group v-model="curOpt">
          <el-radio-button v-for="item in optionsData" :key="item" :label="item" />
        </el-radio-group>
      </el-form-item>
      <el-form-item class="def-num" label="奖项数量：" v-show="curMode == modeList[1]">
        <span class="def-num-sp">
          特等奖：<el-input class="def-num-input" type="number" v-model="defNum[0]" @change="changeDefNum" />
        </span>
        <span class="def-num-sp">
          一等奖：<el-input class="def-num-input" type="number" v-model="defNum[1]" @change="changeDefNum" />
        </span>
        <span class="def-num-sp">
          二等奖：<el-input class="def-num-input" type="number" v-model="defNum[2]" @change="changeDefNum" />
        </span>
        <span class="def-num-sp">
          三等奖：<el-input class="def-num-input" type="number" v-model="defNum[3]" @change="changeDefNum" />
        </span>
      </el-form-item>
      <el-form-item label="参与人员：">
        <el-button class="btn" color="#b79900" @click="isParticipant = true">参与人员</el-button>
      </el-form-item>
      <el-form-item label="抽奖历史：">
        <el-button class="btn" color="#b79900" @click="isHistoryList = true">抽奖历史</el-button>
      </el-form-item>
    </el-form>
    <!-- 中奖弹窗 -->
    <el-dialog v-model="isShowMsg" width="500px" title="抽奖结果" :show-close="true">
      <div class="winner-container">
        <!-- 手动抽奖结果 -->
        <div v-if="curMode == modeList[0]">
          <div v-if="nameList.length === 0">
            <span style="color:#f00; font-size: 18px; text-align: center; display: block;">剩余抽奖人数不足！</span>
          </div>
          <div v-else-if="!manualWinner">
            <span style="color:#f00; font-size: 18px; text-align: center; display: block;">{{ manualWinnerMsg }}</span>
          </div>
          <div v-else class="winner-card">
            <div class="winner-symbol">{{ manualWinner.symbol || '无代号' }}</div>
            <div class="winner-name">{{ manualWinner.name || '无姓名' }}</div>
            <div class="winner-prize">荣获 {{ curOpt }}</div>
          </div>
        </div>
        <!-- 自动抽奖结果 -->
        <div v-if="curMode == modeList[1]">
          <div v-if="curOkList.length === 0">
            <span style="color:#f00; font-size: 18px; text-align: center; display: block;">抽奖失败，请重试！</span>
          </div>
          <div v-else class="winner-list">
            <div v-for="(item, index) in curOkList" :key="item.userId" class="winner-item">
              <div class="winner-rank">{{ index + 1 }}</div>
              <div class="winner-info">
                <div class="winner-symbol">{{ item.symbol || '无代号' }}</div>
                <div class="winner-name">{{ item.name || '无姓名' }}</div>
              </div>
              <div class="winner-prize">{{ item.prize }}</div>
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="isShowMsg = false">确认</el-button>
      </div>
    </el-dialog>
    <!--组件-->
    <div class="com-div">
      <Participant :isParticipant="isParticipant" @close="isParticipant = false" @getNameList="getNameList" />
      <HistoryList :isHistoryList="isHistoryList" @close="isHistoryList = false" />
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus'
import Participant from './Participant.vue';
import HistoryList from './HistoryList.vue';

// 响应式变量
let curPerson = ref({ id: '', userId: '', symbol: '', name: '请开始' }),// 新增id字段（数组索引，确保唯一）
  optionsData = ref(["特等奖", "一等奖", "二等奖", "三等奖"]),
  modeList = ref(['手动抽奖', '自动抽奖']),
  curMode = ref("手动抽奖"),
  curOpt = ref("三等奖"),
  defNum = ref([1, 1, 2, 3]),
  curOkList = ref([]),
  manualWinner = ref(null),
  manualWinnerMsg = ref(""),
  noDataTip = "无数据",
  isStop = ref(true),
  isShowMsg = ref(false),
  isParticipant = ref(false),
  isHistoryList = ref(false),
  nameList = ref([]);

// 初始化：读取本地存储
onMounted(() => {
  const storedData = localStorage.getItem("tabData");
  if (storedData) {
    nameList.value = JSON.parse(storedData).map((item, index) => ({
      ...item,
      id: index // 初始化时添加数组索引作为备用标识
    }));
  }
  if (!localStorage.getItem("luckDrawHis")) {
    localStorage.setItem("luckDrawHis", JSON.stringify([]));
  }
});

// 接收参与人员数据（关键：为每个人员添加唯一id，基于数组索引）
const getNameList = (data) => {
  nameList.value = data.map((item, index) => ({
    name: item.name || '无',
    userId: item.userId || `user_${index}_${Date.now().toString().slice(-4)}`, // 基于索引生成userId，确保唯一
    symbol: item.symbol || '无',
    createdAt: item.createdAt || new Date().toLocaleString(),
    id: index // 数组索引作为备用标识（100%唯一）
  }));
  localStorage.setItem("tabData", JSON.stringify(nameList.value));
  ElMessage.success(`已添加${nameList.value.length}名参与人员`);
};

// 点击抽奖按钮
const clickBtn = () => {
  if (curMode.value === modeList[1]) {
    autoHandle();
  } else {
    isStop.value ? handleStart() : handleStop();
  }
};

// 校验奖项数量
const changeDefNum = () => {
  const isAllPositive = defNum.value.every(num => /^[1-9]\d*$/.test(num));
  if (!isAllPositive) { ElMessage.error('奖项数量必须为正整数！'); return; }
  const totalPrizes = defNum.value.reduce((a, b) => Number(a) + Number(b), 0);
  if (totalPrizes > nameList.value.length) ElMessage.error(`奖项总数（${totalPrizes}）不能超过参与人数（${nameList.value.length}）！`);
};

// 自动抽奖逻辑
const autoHandle = () => {
  const totalPrizes = defNum.value.reduce((a, b) => Number(a) + Number(b), 0);
  if (nameList.value.length === 0) { ElMessage.warning('请先添加参与人员！'); return; }
  if (totalPrizes > nameList.value.length) { ElMessage.error('奖项总数超过参与人数！'); return; }
  if (!defNum.value.every(num => /^[1-9]\d*$/.test(num))) { ElMessage.error('请设置有效的奖项数量！'); return; }

  isStop.value = false;
  const shuffledList = shuffle([...nameList.value]);
  curOkList.value = [];

  setTimeout(() => {
    const luckDrawHis = JSON.parse(localStorage.getItem("luckDrawHis") || "[]");
    const sureTime = new Date().toLocaleString();

    shuffledList.forEach((person, index) => {
      if (index < totalPrizes) {
        let prizeName = optionsData.value[3];
        if (index < defNum.value[0]) prizeName = optionsData.value[0];
        else if (index < defNum.value[0] + defNum.value[1]) prizeName = optionsData.value[1];
        else if (index < defNum.value[0] + defNum.value[1] + defNum.value[2]) prizeName = optionsData.value[2];

        curOkList.value.push({
          prize: prizeName, 
          name: person.name, 
          userId: person.userId, 
          symbol: person.symbol, 
          time: sureTime
        });
      }
    });

    // 存储结果
    luckDrawHis.push(...curOkList.value);
    localStorage.setItem("luckDrawHis", JSON.stringify(luckDrawHis));
    // 更新剩余人员（保留id）
    const winningUserIds = curOkList.value.map(item => item.userId);
    nameList.value = nameList.value
      .filter(person => !winningUserIds.includes(person.userId))
      .map((item, index) => ({ ...item, id: index })); // 重新生成id（确保与索引一致）
    localStorage.setItem("tabData", JSON.stringify(nameList.value));

    isStop.value = true;
    isShowMsg.value = true;
    ElMessage.success(`恭喜${curOkList.value.length}位用户中奖！`);
  }, 1000);
};

// 手动抽奖-开始（滚动时绑定数组索引id）
const handleStart = () => {
  if (nameList.value.length === 0) { ElMessage.warning('请先添加参与人员！'); return; }
  isStop.value = false;
  rollNames();
};

// 手动抽奖-停止（重构匹配逻辑，3层保障）
const handleStop = () => {
  isStop.value = true;
  manualWinner.value = null;
  manualWinnerMsg.value = "";

  if (nameList.value.length === 0) {
    isShowMsg.value = true;
    return;
  }

  // 核心修复：3层匹配逻辑，确保能找到人员
  let winner = null;
  
  // 1. 优先通过数组索引id匹配（100%可靠，因为滚动时绑定的是当前数组的索引）
  winner = nameList.value.find(person => person.id === curPerson.value.id);
  
  // 2. 若id匹配失败，通过userId匹配
  if (!winner) {
    winner = nameList.value.find(person => person.userId === curPerson.value.userId);
  }
  
  // 3. 若前两者都失败，通过name+symbol组合匹配（应对极端情况）
  if (!winner) {
    winner = nameList.value.find(person => 
      person.name === curPerson.value.name && person.symbol === curPerson.value.symbol
    );
  }

  // 处理匹配结果
  if (winner) {
    // 存储中奖记录
    const luckDrawHis = JSON.parse(localStorage.getItem("luckDrawHis") || "[]");
    const newWinner = {
      prize: curOpt.value, 
      name: winner.name, 
      userId: winner.userId, 
      symbol: winner.symbol,
      time: new Date().toLocaleString()
    };
    luckDrawHis.push(newWinner);
    localStorage.setItem("luckDrawHis", JSON.stringify(luckDrawHis));

    // 更新剩余人员（重新生成id，确保与索引一致）
    nameList.value = nameList.value
      .filter(person => person.userId !== winner.userId)
      .map((item, index) => ({ ...item, id: index })); // 重新生成id
    localStorage.setItem("tabData", JSON.stringify(nameList.value));

    manualWinner.value = winner;
    ElMessage.success(`恭喜${winner.name}获得${curOpt.value}！`);
  } else {
    // 极端情况：所有匹配都失败（打印日志便于调试）
    console.error("匹配失败：", { curPerson, nameList: nameList.value });
    manualWinnerMsg.value = "系统异常，未找到该参与人员（详情见控制台）";
  }

  isShowMsg.value = true;
};

// 滚动显示（关键：绑定数组索引id，确保与nameList同步）
const rollNames = () => {
  if (isStop.value) return;
  const shuffled = shuffle([...nameList.value]); // 基于当前nameList洗牌
  let index = 0;
  const rollInterval = setInterval(() => {
    if (isStop.value) { 
      clearInterval(rollInterval); 
      return; 
    }
    // 滚动时绑定当前人员的id（数组索引）、userId、symbol、name
    curPerson.value = {
      id: shuffled[index].id, // 绑定数组索引id（与nameList同步）
      userId: shuffled[index].userId,
      symbol: shuffled[index].symbol,
      name: shuffled[index].name
    };
    index = (index + 1) % shuffled.length;
  }, 80);
};

// 洗牌算法
const shuffle = (arr) => {
  let len = arr.length;
  while (len > 0) {
    const index = Math.floor(Math.random() * len);
    [arr[len - 1], arr[index]] = [arr[index], arr[len - 1]];
    len--;
  }
  return arr;
};
</script>

<style lang="scss" scoped>
/* 样式保持不变，沿用之前优化后的样式 */
:deep(.el-form-item__label) {
  color: #fff;
}

:deep(.el-radio-button__inner) {
  background-color: #b79900;
  font-weight: 900;
  border: 0px solid #f00;
  color: #fff;

  &:hover {
    border: 0px solid #f00;
    color: #fff
  }
}

:deep(.el-radio-button__original-radio:checked+.el-radio-button__inner) {
  background-color: #fd3c3c;
  color: #fff;
  border: 0px solid #f00;
}

// 抽奖显示区域样式（代号+姓名上下结构）
.show-name {
  height: 50vh;
  width: 50vh;
  background-color: rgba(255, 255, 255, .2);
  box-shadow: 0px 0px 20px black;
  margin: auto;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100%;
  user-select: none;
  padding: 20px;

  &:hover {
    background-color: rgba(255, 255, 255, .3);
    box-shadow: 0px 0px 50px black;
  }

  .empty-tip {
    font-size: 8vh;
    font-weight: 900;
    color: #fff;
    text-align: center;
  }

  .person-info {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .symbol-text {
    font-size: 6vh;
    font-weight: 700;
    color: #ffd700;
    text-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    margin-bottom: 10px;
  }

  .name-text {
    font-size: 10vh;
    font-weight: 900;
    color: #fff;
    text-shadow: 0 0 15px rgba(0, 0, 0, 0.7);
  }
}

// 优化后的中奖弹窗样式
:deep(.el-dialog__header) {
  background: linear-gradient(135deg, #ffd700, #ffb800);
  border-radius: 8px 8px 0 0;
  text-align: center;

  .el-dialog__title {
    font-size: 24px;
    font-weight: 700;
    color: #333;
    letter-spacing: 2px;
  }
}

:deep(.el-dialog__body) {
  padding: 30px;
  background-color: #faf8f5;
}

.winner-container {
  width: 100%;
}

// 手动抽奖中奖卡片
.winner-card {
  background: linear-gradient(135deg, #fff8e1, #fff3cd);
  border-radius: 12px;
  padding: 40px 20px;
  text-align: center;
  box-shadow: 0 4px 20px rgba(255, 215, 0, 0.2);
}

.winner-symbol {
  font-size: 28px;
  font-weight: 600;
  color: #d4af37;
  margin-bottom: 15px;
}

.winner-name {
  font-size: 48px;
  font-weight: 900;
  color: #ff6b35;
  margin-bottom: 20px;
  text-shadow: 0 2px 8px rgba(255, 107, 53, 0.3);
}

.winner-prize {
  font-size: 26px;
  font-weight: 700;
  color: #333;
  background-color: #ffd700;
  display: inline-block;
  padding: 8px 30px;
  border-radius: 30px;
  box-shadow: 0 2px 10px rgba(255, 215, 0, 0.3);
}

// 自动抽奖中奖列表
.winner-list {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.winner-item {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-left: 4px solid #ffd700;
}

.winner-rank {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #ffd700;
  color: #333;
  font-size: 20px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 20px;
  flex-shrink: 0;
}

.winner-info {
  flex: 1;
}

.winner-item .winner-symbol {
  font-size: 18px;
  margin-bottom: 5px;
}

.winner-item .winner-name {
  font-size: 24px;
  margin-bottom: 0;
}

.winner-item .winner-prize {
  font-size: 18px;
  padding: 4px 20px;
  margin-left: 20px;
}

.no-winner-tip {
  text-align: center;
  font-size: 20px;
  padding: 30px 0;
}

:deep(.dialog-footer) {
  text-align: center;
  padding: 15px 30px;
  background-color: #faf8f5;
  border-radius: 0 0 8px 8px;

  .el-button--primary {
    background-color: #ffd700;
    border-color: #ffd700;
    color: #333;
    font-size: 18px;
    padding: 8px 40px;

    &:hover {
      background-color: #ffc107;
      border-color: #ffc107;
    }
  }
}

// 原有其他样式保持不变
.container {
  height: 100vh;
  width: 100vw;
  background-image: url(../assets/img/bg1.png);
  background-size: cover;
  background-position: center;
  display: flex;
}

.control-div {
  padding: 2vh;
  width: 30vw;
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, .2);

  .def-num {
    width: 100%;
    color: #ffffff;
    display: flex;

    .def-num-sp {
      background-color: #b79900;
      width: calc(50% - 10px);
      margin: auto;
      padding: 5px;

      .def-num-input {
        width: 45%;
      }
    }
  }

  .btn {
    color: #fff;
  }
}

:deep(.el-form-item__label) { color: #fff; }
:deep(.el-radio-button__inner) {
  background-color: #b79900; font-weight: 900; border: 0; color: #fff;
  &:hover { border: 0; color: #fff; }
}
:deep(.el-radio-button__original-radio:checked+.el-radio-button__inner) {
  background-color: #fd3c3c; color: #fff; border: 0;
}

.show-name {
  height: 50vh; width: 50vh; background-color: rgba(255,255,255,.2);
  box-shadow: 0 0 20px black; margin: auto; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  border-radius: 100%; user-select: none; padding: 20px;
  &:hover { background-color: rgba(255,255,255,.3); box-shadow: 0 0 50px black; }
  .empty-tip { font-size: 8vh; font-weight: 900; color: #fff; text-align: center; }
  .person-info { display: flex; flex-direction: column; align-items: center; width: 100%; }
  .symbol-text { font-size: 6vh; font-weight: 700; color: #ffd700; text-shadow: 0 0 10px rgba(0,0,0,.5); margin-bottom: 10px; }
  .name-text { font-size: 10vh; font-weight: 900; color: #fff; text-shadow: 0 0 15px rgba(0,0,0,.7); }
}

:deep(.el-dialog__header) {
  background: linear-gradient(135deg, #ffd700, #ffb800); border-radius: 8px 8px 0 0; text-align: center;
  .el-dialog__title { font-size: 24px; font-weight: 700; color: #333; letter-spacing: 2px; }
}
:deep(.el-dialog__body) { padding: 30px; background-color: #faf8f5; }
.winner-container { width: 100%; }

.winner-card {
  background: linear-gradient(135deg, #fff8e1, #fff3cd); border-radius: 12px;
  padding: 40px 20px; text-align: center; box-shadow: 0 4px 20px rgba(255,215,0,.2);
}
.winner-symbol { font-size: 28px; font-weight: 600; color: #d4af37; margin-bottom: 15px; }
.winner-name { font-size: 48px; font-weight: 900; color: #ff6b35; margin-bottom: 20px; text-shadow: 0 2px 8px rgba(255,107,53,.3); }
.winner-prize { font-size: 26px; font-weight: 700; color: #333; background-color: #ffd700; display: inline-block; padding: 8px 30px; border-radius: 30px; box-shadow: 0 2px 10px rgba(255,215,0,.3); }

.winner-list { display: flex; flex-direction: column; gap: 15px; }
.winner-item {
  display: flex; align-items: center; background: #fff; border-radius: 8px;
  padding: 15px; box-shadow: 0 2px 10px rgba(0,0,0,.1); border-left: 4px solid #ffd700;
}
.winner-rank { width: 40px; height: 40px; border-radius: 50%; background-color: #ffd700; color: #333; font-size: 20px; font-weight: 700; display: flex; align-items: center; justify-content: center; margin-right: 20px; flex-shrink: 0; }
.winner-info { flex: 1; }
.winner-item .winner-symbol { font-size: 18px; margin-bottom: 5px; }
.winner-item .winner-name { font-size: 24px; margin-bottom: 0; }
.winner-item .winner-prize { font-size: 18px; padding: 4px 20px; margin-left: 20px; }

:deep(.dialog-footer) { text-align: center; padding: 15px 30px; background-color: #faf8f5; border-radius: 0 0 8px 8px;
  .el-button--primary { background-color: #ffd700; border-color: #ffd700; color: #333; font-size: 18px; padding: 8px 40px;
    &:hover { background-color: #ffc107; border-color: #ffc107; }
  }
}

.container { height: 100vh; width: 100vw; background-image: url(../assets/img/bg1.png); background-size: cover; background-position: center; display: flex; }
.control-div { padding: 2vh; width: 30vw; position: absolute; right: 0; bottom: 0; background-color: rgba(0,0,0,.2);
  .def-num { width: 100%; color: #ffffff; display: flex;
    .def-num-sp { background-color: #b79900; width: calc(50% - 10px); margin: auto; padding: 5px;
      .def-num-input { width: 45%; }
    }
  }
  .btn { color: #fff; }
}
</style>